import { DeleteIcon, ResourceMenuActions } from '@all-manager/design-system-v2';
import ConfirmDeleteDialog from '../../../../components/ConfirmDeleteDialog/ConfirmDeleteDialog';
import { useQuoteGroupMenuAction } from './useQuoteGroupMenuAction';

type Props = {
  groupId: string;
  groupName: string;
  size?: 'small' | 'medium';
  afterDeletion?: () => void;
};

export default function QuoteGroupMenuAction(props: Props) {
  const hook = useQuoteGroupMenuAction(props);

  return (
    <>
      <ResourceMenuActions
        size={props.size ?? 'small'}
        tooltip={`Options de « ${props.groupName} »`}
        actions={[
          { id: 'delete', label: 'Supprimer', icon: <DeleteIcon fontSize="small" />, onClick: hook.handleOpenDelete },
        ]}
      />

      {hook.isDeleteOpen ? (
        <ConfirmDeleteDialog
          title="Supprimer la comparaison"
          onConfirm={hook.handleConfirmDelete}
          onClose={hook.handleCloseDelete}
        >
          Supprimer la comparaison « {props.groupName} » et tous ses devis ?
        </ConfirmDeleteDialog>
      ) : null}
    </>
  );
}
